import axios from "./axios";
interface Interest {
    id: number;
    name: string;
    created_at: string;
    updated_at: string;
}

export default async function (): Promise<Interest[]> {
    const { data } = await axios.get("general/interest/list");
    if (data.message == "OK") {
        const interests: Array<any> = [];
        data.data.forEach((d: any) => {
            interests.push(...d.interest);
        });

        return interests;
    }
    return [];
}